{
  "longPressMessage": "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
}
